import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';

import { ScanFlowBreakEffects } from 'app/features/scan-flow/state/scan-flow/scan-flow-break/scan-flow-break.effects';
import { ScanFlowLaborRegistrationEffects } from 'app/features/scan-flow/state/scan-flow/scan-flow-labor-registration/scan-flow-labor-registration.effects';
import { ScanFlowResultRegistrationEffects } from 'app/features/scan-flow/state/scan-flow/scan-flow-result-registration/scan-flow-result-registration.effects';
import { ScanFlowEffects } from 'src/app/features/scan-flow/state/scan-flow/scan-flow.effects';
import { scanFlowFeature } from 'src/app/features/scan-flow/state/scan-flow/scan-flow.reducer';

@NgModule({
    declarations: [],
    imports: [
        StoreModule.forFeature(scanFlowFeature),
        EffectsModule.forFeature([
            ScanFlowEffects,
            ScanFlowBreakEffects,
            ScanFlowLaborRegistrationEffects,
            ScanFlowResultRegistrationEffects,
        ]),
    ],
})
export class ScanFlowStateModule {}
